import {AfterViewInit, Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {IntercomService, SessionService, User} from '@q9elements/ui-kit/common';

@Component({
  standalone: true,
  selector: 'q9ma-decision-engine-wrapper',
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styles: [
    `
      :host {
        display: block;
        height: 100vh;
        width: 100vw;
      }
    `
  ]
})
export class DecisionEngineWrapperComponent implements AfterViewInit {
  private readonly sessionService = inject(SessionService);
  private readonly intercomService = inject(IntercomService);

  ngAfterViewInit() {
    const user = this.sessionService.user() as User;

    this.intercomService.bootIntercom(user);
  }
}
